export enum DebtCustomerStatus {
    Collected = 1,
    NotYetCollect = 2,
    Payed = 3,
    NotYetPay = 4,
}